import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { Page } from "@/shared/components/ui/Page";
import { CardSetupFlow } from "../components/CardSetupFlow";
import { CardSetupLayout } from "../components/CardSetupLayout";

export function PaymentMethodSetupPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.hash.slice(1));
  const token = params.get("token");
  const valid = token && /^[A-Za-z0-9_-]{43}$/.test(token) && [...params.keys()].length === 1;
  useEffect(() => {
    // Stripe redirects can append a client secret; discard it before loading any payment UI.
    if (location.search) navigate({ pathname: location.pathname, hash: location.hash }, { replace: true });
  }, [location.pathname, location.search, location.hash, navigate]);
  return <div className="h-dvh"><Page>
    <meta name="referrer" content="no-referrer" />
    <meta name="robots" content="noindex, nofollow" />
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto overscroll-contain">
      {location.search ? <CardSetupLayout><LoadingSpinner message="Checking return from Stripe..." /></CardSetupLayout> :
        valid ? <CardSetupFlow key={token} token={token} /> :
          <CardSetupLayout><ErrorState message="This card setup link is invalid. Ask the business for a new link." /></CardSetupLayout>}
    </div>
  </Page></div>;
}
